import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { CampaignsService } from '@autoinformer/services/CampaignsService';

// const worktimes = [
//   {
//     day: 0,
//     start: '09:00',
//     end: '13:00'
//   },
//   {
//     day: 0,
//     start: '14:00',
//     end: '19:00'
//   },
//   {
//     day: 1,
//     start: '09:00',
//     end: '13:00'
//   },
//   {
//     day: 1,
//     start: '14:00',
//     end: '19:00'
//   }
// ];

const getWeekday = (day) => {
  var days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  return days[day];
};

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) =>
        CampaignsService.getList(params).then(({ meta, data }) => {
          return {
            meta,
            data: data.map((i) => ({
              ...i,
              worktimes: i.worktime?.map((i) => ({ ...i, day: getWeekday(i.day) }))
            }))
          };
        })
    }
  },
  true
);
